import actions from './actions'

const createLocalStorage = () => {
  const get = (key, defaultValue = null) => {
    try {
      const value = window.localStorage.getItem(key)
      return value !== null ? value : defaultValue
    } catch (error) {
      return defaultValue
    }
  }

  const set = (key, value) => {
    try {
      return window.localStorage.setItem(key, value)
    } catch (error) {}
  }

  return {
    get,
    set
  }
}

const init = (store, location) => {
  const { hash, search } = location
  const localStorage = createLocalStorage()

  let realm
  if (hash === '#realm=klarna') {
    realm = 'klarna'
  } else if (hash === '#realm=merchants') {
    realm = 'merchants'
  } else {
    realm = localStorage.get('realm', 'merchants')
  }
  store.dispatch(actions.keycloak.realm.set(realm))

  const searchParams = new URLSearchParams(search)
  let isPartner = false
  if (searchParams.has('partner')) {
    isPartner = searchParams.get('partner') === 'true'
    localStorage.set('partner', isPartner)
  } else {
    localStorage.get('partner', false)
  }
  store.dispatch(actions.isPartner.set(isPartner))
}

export default init
